import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function ProblemSection() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-149">
      <div className="max-w-3xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-152">
            Así funciona hoy y pagas de más
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-153">
            Buscas en portales, hablas con corredores y visitas propiedades sin
            estrategia. Si te gusta una, terminas comprando con quien representa
            al vendedor y pagándole un 2% del valor de la casa.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="mb-10" data-id="element-154">
          <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-5" data-id="element-155">
            El problema
          </p>
          <ul className="space-y-4" data-id="element-156">
            {['No elegiste quién te asesora', 'No trabaja para ti', 'Y aun así, pagas cerca de un 2% de comisión'].map(text => <motion.li key={text} variants={itemVariants} className="flex items-center gap-3" data-id="element-157">
                <XCircle className="text-red-500 shrink-0" size={20} data-id="element-158" />
                <span className="text-base text-gray-800 font-medium" data-id="element-159">
                  {text}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-red-50 border border-red-100 rounded-2xl p-6 md:p-8 flex items-start gap-4" data-id="element-160">
          <AlertTriangle className="text-red-500 shrink-0 mt-0.5" size={22} data-id="element-161" />
          <p className="text-lg font-semibold text-gray-900 leading-snug" data-id="element-162">
            Estás tomando una de las decisiones financieras más grandes de tu
            vida con alguien que no está de tu lado.
          </p>
        </motion.div>
      </div>
    </section>;
}